export const fetchEpgItems = async () => {
  try {
    const response = await axios.get('/api/v1/epg/items');
    return response.data;
  } catch (e) {
    console.error(`Error occurred getting schedule items -> ${e}`);
  }
};

export const addEpgItem = async (name) => {
  try {
    const response = await axios.get('/epg/create', {
      params: {
        name: name,
      },
    });
    return response.data.data.item;
  } catch (error) {
    window.handleAxiosError(error);
    console.error(`Error occurred adding epg -> ${error}`);
  }
};

export const deleteEpgItem = async (uuid) => {
  try {
    const response = await axios.delete(`/api/v1/epg/items/${uuid}`);
    return response.data.data;
  } catch (err) {
    window.handleAxiosError(err);
    console.error(`Error occurred deleting epg -> ${err}`);
  }
};
